<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <h4>Solicitante</h4>

        <div class="row">
            <div class="col-md-12">
                <!--CABECERA REPRESENTANTE-->
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedDatosRepresentante = !isCollapsedDatosRepresentante"
                       [attr.aria-expanded]="!isCollapsedDatosRepresentante" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Datos del Representante
                            <i *ngIf="isCollapsedDatosRepresentante" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosRepresentante" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapsedDatosRepresentante" [ngbCollapse]="isCollapsedDatosRepresentante">
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intEstado">Nombre</label>
                                    <input readonly formControlName="Nombre" name="Nombre" title="" class="form-control" id="inpNombre" type="text" value="">
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpDescripcion">Apellidos</label>
                                    <input readonly formControlName="Apellidos" name="Apellidos" title="" class="form-control" id="inpApellidos" type="text" value="">
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intEstado">NIF / NIE / Pasaporte</label>
                                    <input readonly formControlName="NIF" name="NIF" title="" class="form-control" id="inpNIF" type="text" value="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--DATOS DE CONTACTO-->
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedDatosContacto = !isCollapsedDatosContacto"
                       [attr.aria-expanded]="!isCollapsedDatosContacto" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Datos de Contacto
                            <i *ngIf="isCollapsedDatosContacto" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosContacto" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapsedDatosContacto" [ngbCollapse]="isCollapsedDatosContacto">
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intEstado">Nº Teléfono</label>
                                    <input readonly formControlName="NumeroTelefono" name="NumeroTelefono" title="" class="form-control" id="" type="text" value="">
                                </div>
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpDescripcion">Fax</label>
                                    <input readonly formControlName="NumeroFax" name="NumeroFax" title="" class="form-control" id="" type="text" value="">
                                </div>
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpDescripcion">Correo Electrónico</label>
                                    <input readonly formControlName="Email" name="Email" title="" class="form-control" id="" type="text" value="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--DATOS DE LA ORGANIZACIÓN-->
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedDatosOrganizacion = !isCollapsedDatosOrganizacion"
                       [attr.aria-expanded]="!isCollapsedDatosOrganizacion" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Datos de la Organización
                            <i *ngIf="isCollapsedDatosOrganizacion" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosOrganizacion" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapsedDatosOrganizacion" [ngbCollapse]="isCollapsedDatosOrganizacion">
                            <div class="row">
                                <div class="form-group col-md-8">
                                    <label class="col-form-label" for="intEstado">Razón Social</label>
                                    <input readonly formControlName="RazonSocial" name="RazonSocial" title="" class="form-control" id="" type="text" value="">
                                </div>
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpDescripcion">País</label>
                                    <input readonly formControlName="IdPaisDescripcion" name="IdPaisDescripcion" title="" class="form-control" id="" type="text" value="">
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intEstado">Localidad</label>
                                    <input readonly formControlName="Localidad" name="Localidad" title="" class="form-control" id="" type="text" value="">
                                </div>
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpDescripcion">NIF</label>
                                    <input readonly formControlName="NifCifRazonSocial" name="NifCifRazonSocial" title="" class="form-control" id="" type="text" value="">
                                </div>
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpDescripcion">Provincia</label>
                                    <input readonly formControlName="IdProvinciaDescripcion" name="IdProvinciaDescripcion" title="" class="form-control" id="" type="text" value="">
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="intEstado">Tipo vía pública</label>
                                    <input readonly formControlName="IdTipoViaDescripcion" name="IdTipoViaDescripcion" title="" class="form-control" id="" type="text" value="">
                                </div>
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpDescripcion">Nombre</label>
                                    <input readonly formControlName="NombreVia" name="NombreVia" title="" class="form-control" id="" type="text" value="">
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="col-form-label" for="inpDescripcion">Nº</label>
                                    <input readonly formControlName="NumeroPortal" name="NumeroPortal" title="" class="form-control" id="" type="text" value="">
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="col-form-label" for="inpDescripcion">C.P.</label>
                                    <input readonly formControlName="CodigoPostal" name="CodigoPostal" title="" class="form-control" id="" type="text" value="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</form>
